import * as React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import {
  BoundScrollProvider,
  NoticeBannersStackProvider,
} from '@sweetgreen/garnish';

import { AsyncStorageProvider } from '@order/AsyncStorage';
import { AuthFlowProvider } from '@order/AuthFlow';
import { BrazeProvider } from '@order/Braze';
import { ChallengesAndRewardsProvider } from '@order/ChallengesAndRewards';
import { CustomerProvider } from '@order/Customer';
import { GlobalAppState } from '@order/GlobalAppState';
import { LaunchDarklyProvider } from '@order/LaunchDarkly';
import { LocalizationProvider } from '@order/Localization';
import { OneSignalProvider } from '@order/OneSignal';
import { TelemetryProvider } from '@order/Telemetry';

export const Providers = (props: Pick<ViewProps, 'children'>) => (
  <SafeAreaProvider>
    <GestureHandlerRootView style={StyleSheet.absoluteFill}>
      <AsyncStorageProvider>
        <GlobalAppState>
          <NoticeBannersStackProvider>
            <LocalizationProvider>
              <TelemetryProvider>
                <CustomerProvider>
                  <LaunchDarklyProvider>
                    <BrazeProvider>
                      <OneSignalProvider>
                        <ChallengesAndRewardsProvider>
                          <AuthFlowProvider>
                            <BoundScrollProvider>
                              {props.children}
                            </BoundScrollProvider>
                          </AuthFlowProvider>
                        </ChallengesAndRewardsProvider>
                      </OneSignalProvider>
                    </BrazeProvider>
                  </LaunchDarklyProvider>
                </CustomerProvider>
              </TelemetryProvider>
            </LocalizationProvider>
          </NoticeBannersStackProvider>
        </GlobalAppState>
      </AsyncStorageProvider>
    </GestureHandlerRootView>
  </SafeAreaProvider>
);
